import { render, staticRenderFns } from "./HeaderRecommendations.vue?vue&type=template&id=73e38709"
import script from "./HeaderRecommendations.vue?vue&type=script&lang=js"
export * from "./HeaderRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports